import { isWithinInterval, parseISO, subDays } from 'date-fns';

import envConfig from '../../config/env';

const isRugNew = (createdAt: string) => {
  return isWithinInterval(parseISO(createdAt), { end: Date.now(), start: subDays(Date.now(), envConfig.rugIsNewDays) });
};

export default isRugNew;
